declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIvfCycleInseminationLogRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from './searchprovider.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'ngbeditinseminationlog',
    templateUrl: './editinseminationlog.modal.html',
    styleUrls: ['./editinseminationlog.modal.scss']
})

export class NgbEditInseminationLogModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode;
    @Input() IsShowDetail: boolean = false;
    @Input() Gradingmodel: string;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() CurrentSaveIvfCycleInseminationLogRequest: SaveIvfCycleInseminationLogRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    public ApiResData: ApiResponseModel;
    public maxDate: NgbDateStruct;
    public minDate: NgbDateStruct;
    public ProviderName: string;
    public ProviderCode: number;
    public NurseName: string;
    public NurseCode: number;
    public ProvidedName: string;
    public ProvidedCode: number;
    public Doctorn: boolean = true;
    public Doctornew: boolean = false;
    public Processedn: boolean = true;
    public Processednew: boolean = false;
    public Nursen: boolean = true;
    public Nursenew: boolean = false;
    public InseminationDate: NgbDateStruct;
    public Time: NgbDateStruct;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    //public IsSelected: boolean;
    CurrentActorAddEmergencyInfoRequest: SaveEmergencyContactInfoRequest;

    constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
        private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
        private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
        private tosterservice: NGXToastrService) { }
    ngOnInit() {
        //alert(this.Gradingmodel);
        //this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
        //this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
        //this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
        //this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
        //this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.ShowService = false;
        //alert(this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate);
        if (this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate != null) {
            var SValidFrom = new Date(this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate);
            if (SValidFrom.getFullYear() > 1900) {
                console.log('this.InseminationDate >1990');
                this.InseminationDate = {

                    year: SValidFrom.getFullYear(),
                    month: SValidFrom.getMonth() + 1,
                    day: SValidFrom.getDate()
                }
            }
        }

        this.LoadRegistries();


    }




    LoadRegistries() {
        this.StartRefreshing();



        //this.GetBranchMap();


    }

    DoctorSelection() {
        this.Doctorn = false;
        this.Doctornew = true;
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowDoctor = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProviderName = receivedEntry.make;
            this.ProviderCode = receivedEntry.value;
            this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = this.ProviderName;
            this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = this.ProviderCode;
            //alert(this.ProviderName);
        })
    }
    NurseSelection() {
        this.Nursen = false;
        this.Nursenew = true;
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowNurse = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.NurseName = receivedEntry.make;
            this.NurseCode = receivedEntry.value;
            this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = this.NurseCode;
            this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = this.NurseName;

            //alert(this.NurseName);
        })
    }
    ProvidedSelection() {
        this.Processedn = false;
        this.Processednew = true;
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowProvieded = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProvidedName = receivedEntry.make;
            this.ProvidedCode = receivedEntry.value;
            //alert(this.ProvidedName);
            this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = this.ProvidedCode;
            this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = this.ProvidedName;
        })
    }

    onSubmit() {
        this.spinner.show();
        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveIvfCycleInseminationLogRequest.ConditionalOperator = 1;

        this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate = new Date(this.parserFormatter.format(this.InseminationDate));
        //this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = this.ProviderName;
        //this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = this.ProviderCode;
        //this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = this.ProvidedCode;
        //this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = this.ProvidedName;
        //this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = this.NurseCode;
        //this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = this.NurseName;
        this.actorservice.SaveIvfCycleInseminationLog(this.CurrentSaveIvfCycleInseminationLogRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();
                        this.activeModal.close();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        this.activeModal.close();


                    }
                    else {
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

    }

    onAssignedToActorCodeEmbryologist(event: any) {

        if (event != null) {

            this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = event;
            this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = event;

        }

    }

    onAssignedToActorCodeEmbryologist1(event: any) {

        if (event != null) {

            this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = event;
            this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = event;

        }

    }

    onAssignedToActorCodeEmbryologist2(event: any) {

        if (event != null) {

            this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = event;
            this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = event;

        }

    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }





}
